export type AppLanguage = 'he' | 'en' | 'ar' | 'ru';

export const translations = {
  he: {
    appTitle: 'Clicks Tourism 360',
    branding: {
      poweredBy: 'מופעל על ידי',
      companyName: 'Clicks Strategic Ecosystems',
    },
    landing: {
      eyebrow: 'פורטל יזמים · גליל מזרחי',
      title: 'בדיקת התאמת מגרש לתיירות',
      subtitle:
        'בחרו מגרש במפה, קבלו הערכת זמינות קרקע ומידע תכנוני — ואז מלאו פרטי יזם לפתיחת תיק.',
      stepsHeading: 'מה מקבלים בתהליך',
      onboardAria: 'שלבי הבדיקה',
      steps: [
        {
          title: 'בחירת מגרש',
          description: 'ייעוד קרקע, תוכניות ומספר מגרש על מפת הקומפילציה',
        },
        {
          title: 'הערכת זמינות קרקע ומידע תכנוני',
          description: 'אות תנועה לפי ייעוד ודוח תיקון 119 — לפני מילוי פרטי יזם',
        },
        {
          title: 'מילוי פרטי יזם',
          description: 'פרטי מיזם, יצירת קשר והסכמה לפתיחת תיק במערכת',
        },
      ],
      startCta: 'התחלת בדיקה',
      startWizard: 'התחלת בדיקה',
      starting: 'פותחים סשן…',
      startError: 'לא ניתן להתחיל כרגע. נסו שוב.',
      intakeSuccessTitle: 'התיק נפתח בהצלחה',
      intakeSuccessBody: 'ניתן להתחיל בדיקה חדשה בלחיצה על הכפתור למטה.',
      privacyLink: 'מדיניות פרטיות ושימוש במידע',
      privacyHref: '/docs/entrepreneur/assessment',
      eshkolLogoAlt: 'אשכול גליל מזרחי',
    },
    wizard: {
      title: 'תהליך בדיקת מגרש',
      subtitle: 'מלאו את פרטי המיזם, מספר מגרש ומיקום במפה (גליל מזרחי בלבד)',
      journeySubtitle: 'מילוי פרטי יזם — לאחר בחירת המגרש במפה',
      stepperAria: 'שלבי השאלון',
      journeyStepperAria: 'התקדמות בתהליך הבדיקה',
      journeyCompletedLabel: 'הושלמו:',
      journeySteps: {
        map: 'בחירת מגרש',
        assessment: 'הערכה ומידע תכנוני',
      },
      journeyStepsCompact: {
        map: 'מגרש',
        assessment: 'חיווי',
      },
      intakePhaseTitle: 'מילוי פרטי יזם',
      intakeStepProgress: '{step} · שלב {current} מתוך {total}',
      navAria: 'ניווט בשאלון',
      back: 'חזרה',
      next: 'המשך',
      finish: 'אישור והמשך',
      finishing: 'שומרים וממשיכים…',
      errorTitle: 'שגיאה',
      completeTitle: 'השאלון הושלם',
      completeBody:
        'תודה! המגרש שבחרתם בשלב פרטי המיזם יאושר אוטומטית. תגיעו למפה רק אם נדרש אישור חוזר.',
      steps: {
        venture: 'פרטי מיזם',
        contact: 'יצירת קשר',
        review: 'סיכום',
        consent: 'הסכמה',
      },
      fields: {
        ventureType: 'סוג מיזם',
        ventureTypePlaceholder: 'בחרו סוג מיזם',
        requiredArea: 'שטח נדרש (מ"ר)',
        requiredAreaPlaceholder: 'לדוגמה: 1200',
        timeline: 'לוח זמנים',
        timelinePlaceholder: 'בחרו לוח זמנים',
        contactName: 'שם מלא',
        contactNamePlaceholder: 'שם היזם',
        contactPhone: 'טלפון',
        contactPhonePlaceholder: '501234567',
        contactPhonePrefix: 'קידומת',
        contactEmail: 'אימייל',
        contactEmailPlaceholder: 'name@example.com',
        parcelSection: 'מיקום המגרש (שכבת קומפילציה)',
        migrash: 'מספר מגרש',
        migrashPlaceholder: 'לדוגמה: 2145 (מתב"ע)',
        mapLocation: 'מיקום במפה',
        mapHint:
          'לחצו על אזור צבוע במפת ייעודי קרקע — הייעוד יוצג בבדיקת ההתאמה',
        mapAriaLabel: 'מפת גליל מזרחי לבחירת מיקום',
        mapSelectedPrefix: 'נקודה נבחרה:',
      },
      ventureTypes: {
        hotel: 'מלון',
        bnb: 'צימרים / B&B',
        glamping: 'גלמפינג',
        commercial_tourism: 'תיירות מסחרית',
        other: 'אחר',
      },
      timelines: {
        immediate: 'מיידי (עד 3 חודשים)',
        within_6_months: 'עד 6 חודשים',
        within_1_year: 'עד שנה',
        exploring: 'בשלב בדיקה / ללא לוח קשיח',
      },
      units: {
        sqm: 'מ"ר',
      },
      reviewIntro: 'בדקו שהפרטים נכונים לפני המשך לאישור והסכמה.',
      reviewVentureSection: 'פרטי מיזם',
      reviewContactSection: 'פרטי קשר',
      validation: {
        ventureTypeRequired: 'נא לבחור סוג מיזם',
        requiredAreaRequired: 'נא להזין שטח חיובי במ"ר',
        timelineRequired: 'נא לבחור לוח זמנים',
        migrashRequired: 'נא להזין מספר מגרש',
        migrashInvalid: 'מספר מגרש לא תקין',
        mapLocationRequired: 'נא ללחוץ על אזור ייעודי קרקע במפה (שכבת קומפילציה)',
        mapIdentifyFailed: 'לא נמצא מגרש בנקודה זו — לחצו על גבול מגרש בשכבת הקומפילציה',
        contactNameRequired: 'נא להזין שם',
        contactPhoneInvalid: 'מספר טלפון לא תקין',
        contactEmailInvalid: 'כתובת אימייל לא תקינה',
        consentRequired: 'יש לאשר את ההצהרה כדי להמשיך',
      },
      consent: {
        noticeTitle: 'הבהרה חשובה',
        noticeBody:
          'המידע באתר הוא לצורכי התאמה ראשונית בלבד ואינו מהווה אישור תכנוני, היתר או התחייבות מצד הרשות.',
        savingHint: 'שומרים את האישור — זה עשוי לקחת מספר שניות.',
        checklistTitle: 'יש לאשר את כל הסעיפים כדי להמשיך:',
        checklistItems: {
          informational:
            'הבנתי שהמידע באתר הוא לצורכי התאמה ראשונית בלבד ואינו מהווה אישור תכנוני או היתר',
          dataProcessing:
            'אני מסכים/ה לעיבוד פרטי הקשר והמידע שאספק לצורך בדיקת המגרש ופתיחת תיק יזם',
          layers:
            'הבנתי שהמידע התכנוני מבוסס על שכבות GIS ציבוריות (קומפילציה, XPLAN) ועלול להיות חלקי',
        },
        checkboxLabel:
          'קראתי והבנתי שהבדיקה היא מידעית בלבד ואינה מבטיחה קבלת היתר',
        checkboxAria: 'אישור הצהרת אחריות',
        openFileTitle: 'אישור ופתיחת תיק יזם',
        openFileConfirm:
          'אני מאשר/ת שהמידע לעיל נבדק ומבקש/ת לפתוח תיק יזם במערכת',
        submitConfirmRequired: 'נא לאשר את הבקשה לפני שליחה',
        submit: 'פתיחת תיק יזם',
        submitLoading: 'שולח תיק יזם…',
        submitSuccess: 'התיק נפתח בהצלחה',
        submitError: 'שגיאה בפתיחת התיק',
        submitProfileRequired: 'נא למלא את פרטי היזם לפני שליחה',
      },
    },
    langSelect: {
      languageLabel: 'שפה',
      hebrew: 'עברית',
      english: 'English',
      arabic: 'العربية',
      russian: 'Русский',
      chooseLanguageAria: 'בחירת שפה',
    },
    header: {
      docs: 'מדריך משתמש',
    },
    map: {
      title: 'בחירת מגרש',
      subtitle: 'לחצו על אזור צבוע במפת ייעודי קרקע (קומפילציה) — גליל מזרחי בלבד',
      hint: 'לחצו על פוליגון צבוע בשכבת ייעודי קרקע — הייעוד והתוכניות יוצגו בשלב הבא',
      clickToSelect: 'לחיצה על המפה',
      drawPolygon: 'צייר מגרש',
      selectionModeGroupLabel: 'אופן בחירת מגרש על המפה',
      drawHint: 'סמנו את גבולות המגרש על המפה — לחצו להתחיל, לחצו שוב לסגירת הפוליגון',
      clearDrawing: 'נקה שרטוט',
      drawnAreaLabel: 'שטח מסומן',
      mapAriaLabel: 'מפת גליל מזרחי לבחירת מגרש',
      expandMap: 'הגדלת מפה',
      collapseMap: 'הקטנת מפה',
      layersLoading: 'טוען שכבת ייעודי קרקע…',
      confirmTitle: 'אשרו את המיקום',
      confirmBody: 'המיקום נבחר. ייעוד ותוכניות יוצגו בבדיקת ההתאמה ובדף המידע התכנוני.',
      confirmButton: 'אישור והמשך',
      confirmButtonLoading: 'שומר מגרש…',
      completeTitle: 'המגרש נשמר',
      completeBody: 'בחירת המגרש נשמרה. בשלב הבא תוצג בדיקת התאמה (בקרוב).',
      errorTitle: 'שגיאה',
      fields: {
        migrash: 'מספר מגרש',
        planPrimary: 'תוכנית עיקרית',
        plansAffecting: 'תוכניות באזור',
        plansAtPoint: 'תוכניות בנקודה (קווים כחולים)',
        settlement: 'יישוב',
        designation: 'ייעוד',
        area: 'שטח (קומפילציה)',
        coordinates: 'קואורדינטות',
        cadastralRef: 'גוש/חלקה (רישום, לעיון)',
      },
      validation: {
        identifyFailed: 'לא נמצא ייעוד בנקודה זו — לחצו על אזור צבוע בשכבת ייעודי קרקע',
        identifyTimeout: 'זיהוי הייעוד לקח יותר מדי זמן — נסו שוב או בחרו נקודה אחרת',
      },
      legend: {
        title: 'מקרא',
        loading: 'טוען מקרא מהקומפילציה (XPlan)…',
        loadError: 'לא ניתן לטעון מקרא — נסו לרענן את הדף',
        summaryHint: 'סיווגים מרכזיים לתיירות — לחצו על אזור צבוע במפה',
        showFull: 'מקרא מלא ({count})',
        mapFilterOpen: 'סינון ייעודים על המפה ({count})',
        mapFilterActive: 'מוצגים על המפה: {shown}/{total}',
        mapFilterTitle: 'ייעודי קרקע על המפה — {layer}',
        mapFilterIntro: 'סמנו אילו ייעודים יוצגו בשכבת הקומפילציה. השינוי חל מיד על המפה.',
        mapVisibleMeta: '{shown} מתוך {total} ייעודים מוצגים על המפה',
        selectAll: 'הצג הכל',
        selectTourism: 'תיירות בלבד',
        selectNone: 'הסתר הכל',
        fullTitle: 'מקרא — {layer}',
        fullMeta: '{count} סיווגים בשכבת הקומפילציה (XPlan)',
        filteredMeta: '{shown} מתוך {total} סיווגים',
        filterLabel: 'חיפוש ברשימה',
        filterPlaceholder: 'חיפוש ייעוד (למשל תיירות, נופש, כפרי…)',
        filterEmpty: 'לא נמצאו סיווגים — נסו מילה אחרת',
        close: 'סגור',
        approvalDateHint: 'תאריך אישור תוכנית מוצג בדף המידע התכנוני (§2)',
      },
    },
    assessment: {
      title: 'בדיקת התאמת מגרש',
      combinedTitle: 'הערכת זמינות קרקע ומידע תכנוני',
      combinedSubtitle:
        'לאחר מילוי הפרטים והסכמה — מוצגים חיווי התאמה ודוח המידע התכנוני; אינם מהווים אישור היתר',
      statusRevealLoading: 'בודקים זמינות קרקע…',
      statusRevealHint: 'מנתחים ייעוד בשכבת הקומפילציה וטוענים את דוח המידע התכנוני',
      continueToQuestionnaire: 'מילוי פרטי יזם והמשך',
      continueToQuestionnaireHint: 'לאחר מילוי הפרטים תוכלו לפתוח תיק יזם במערכת',
      finishJourney: 'סיום',
      finishJourneyHint: 'חזרה לדף הבית — התיק נפתח בהצלחה',
      ctaWaitingForReport: 'הכפתור יופעל לאחר טעינת דוח המידע התכנוני',
      subtitle: 'הערכה מהירה לפי ייעוד קרקע בשכבת הקומפילציה — אינה מהווה אישור היתר',
      loading: 'טוען הערכת התאמה…',
      errorTitle: 'שגיאה',
      designationTitle: 'ייעוד קרקע',
      detailsTitle: 'פרטי ההערכה',
      ctaHint: 'שלב אופציונלי — דוח תיקון 119 מלא (טעינה איטית יותר)',
      trafficLight: {
        green: 'ירוק — מיועד לתיירות',
        yellow: 'צהוב — אולי (מגורים / חקלאי / ישוב)',
        red: 'אדום — שמורת טבע, כבישים ודרכים',
        unknown: 'לא מסווג במפה',
      },
      viewPlanningInfo: 'מידע תכנוני מלא',
      verdictTitle: 'פסק דין',
      verdict: {
        yes: 'כן',
        no: 'לא',
        conditional: 'בתנאים',
        unknown: 'לא ידוע',
      },
      submit: 'פתיחת תיק יזם',
      submitLoading: 'שולח תיק יזם…',
      submitSuccess: 'התיק נפתח בהצלחה',
      submitError: 'שגיאה בפתיחת התיק',
      submitPlaceholder: 'פתיחת תיק יזם (בקרוב)',
      unknownNote: 'לא ניתן להעריך את המגרש כרגע — נציג הוועדה יחזור אליכם לאחר בדיקה.',
      status: {
        available: 'מתאים',
        conditional: 'מתאים בתנאים',
        unlikely: 'סבירות נמוכה',
        unknown: 'לא ידוע',
      },
      rules: {
        pass: 'עבר',
        fail: 'נכשל',
        skip: 'לא רלוונטי',
      },
    },
    planningInfo: {
      title: 'התכנות סטטוטורית-תכנונית להקמת מיזם תיירות',
      ramzorLabel: 'בדיקת התאמה',
      subtitle: 'סיכום מידע תכנוני לפי המגרש שנבחר',
      loading: 'טוען מידע תכנוני…',
      reportLoading: 'טוען דוח תכנוני ומחלץ זכויות מהתקנון…',
      errorTitle: 'שגיאה',
      disclaimerTitle: 'הבהרה חשובה',
      disclaimerBody:
        'המידע המוצג כאן הוא תמצית מידע תכנוני לצורכי התאמה ראשונית בלבד. הוא אינו מהווה אישור תכנוני, היתר בנייה או התחייבות מצד הרשות. לבקשה רשמית פנו למערכת VGM.',
      lineageFooter: 'מקור הנתונים: XPLAN (מינהל התכנון), GovMap cadastral. המידע עשוי להשתנות.',
      reportDate: 'תאריך דוח',
      requestType: 'סוג בקשה',
      section1Title: '1. פרטי הקרקע',
      section2Title: '2. תוכניות הנוגעות לקרקע',
      section3Title: '3. זכויות והגבלות בנייה',
      section4Title: '4. הערות',
      missingSession: 'חסר מזהה סשן',
      exportPrintFallback:
        'לא ניתן לייצא PDF — נפתחה תצוגת הדפסה; בחרו בהדפסה → שמירה כ-PDF.',
      openXplanLink: 'צפייה במערכת XPLAN (מינהל התכנון)',
      xplanLineage: 'תוכניות וייעוד מ-XPLAN; לא דוח תיקון 119 של ועדה מקומית.',
      xplanFallbackNote:
        'לא נטענו נתוני XPLAN — ודאו שנבחר מגרש במפה (נדרש מרכז גיאוגרפי). אפשר לפתוח את XPLAN ישירות.',
      openOfficialReport: 'פתיחת XPLAN',
      vgmMatchNote: '',
      officialVgmLink: 'XPLAN',
      fetchStatus: {
        complete: '',
        partial: 'חלק מהנתונים לא זמינים — מוצגת תמצית חלקית.',
        failed: 'לא ניתן היה לטעון את כל המידע התכנוני.',
      },
      documentsTitle: 'מסמכים רשמיים (תקנון)',
      documentsEmpty: 'קישור לתקנון לא זמין — נסו שוב מאוחר יותר.',
      takanonNotFoundTitle: 'לא נמצא מסמך תקנון',
      takanonNotFoundBody:
        'לא הצלחנו למצוא מסמך תקנון עבור התוכנית. מוצגים פרטי הקרקע והתוכניות מ-XPLAN בלבד.',
      expandTakanonRights: 'הרחב זכויות מהתקנון',
      expandTakanonLoading: 'מחלץ זכויות מהתקנון…',
      extractionBannerTitle: 'חילוץ תקנון חלקי',
      extractionBannerBody:
        'חלק מזכויות הבנייה לא חולצו מהתקנון. מוצגים §1–§2 מ-XPLAN וקישור למסמך המקורי.',
      extractionNotice:
        'ערכים מתוך קריאה אוטומטית של התקנון — טיוטה; יש לבדוק מול המקור הרשמי.',
      extractionSectionDraftNotice: 'טיוטה — לא אומת',
      extractionDraftBannerTitle: 'תקנון — לא אומת',
      extractionDraftBannerBody:
        'ערכים מתוך קריאה אוטומטית — לא אומתו מול התקנון. יש לפתוח את ה-PDF ולאמת ידנית.',
      verifySource: 'אימות מול המקור',
      openPdfOnPage: 'פתיחת PDF בעמוד',
      lowConfidence: 'ביטחון נמוך',
      submitTitle: 'אישור ופתיחת תיק יזם',
      submitConfirm:
        'אני מאשר/ת שהמידע לעיל נבדק ומבקש/ת לפתוח תיק יזם במערכת',
      submitConfirmRequired: 'נא לאשר את הבקשה לפני שליחה',
      submitProfileIntro:
        'לפני פתיחת התיק ב-monday, נא למלא את פרטי היזם (גם אם דילגתם על שלבי השאלון):',
      submitProfileRequired: 'נא למלא שם יזם וסוג מיזם',
      submit: 'פתיחת תיק יזם',
      submitLoading: 'שולח תיק יזם…',
      submitSuccess: 'התיק נפתח בהצלחה',
      submitError: 'שגיאה בפתיחת התיק',
      exportPdf: 'ייצוא PDF',
      exportingPdf: 'מייצא PDF…',
      exportPdfError: 'לא ניתן לייצא PDF. נסו שוב.',
      pdfProducedBy: 'Produced by Clicks Strategic Ecosystems',
      pdfPage: 'עמוד',
      pdfProductName: 'Clicks Tourism 360',
      pdfProductTagline: 'מודיעין תכנוני — גליל מזרחי',
      reportCoverSubtitle: 'דוח מידע תכנוני מובנה לפי המגרש שנבחר',
      reportInformationalNotice:
        'דוח זה הוא תמצית מידע תכנוני לצורכי התאמה ראשונית בלבד — אינו מהווה אישור תכנוני, היתר בנייה או התחייבות מצד הרשות.',
      reportDocumentRef: 'מזהה מסמך',
      reportSourceLabel: 'מקור נתונים',
      report: {
        coverBadge: 'תיקון 119',
        parcelCadastralLine: 'גוש {gush} / חלקה {helka}',
        fields: {
          settlement: 'יישוב',
          gush: 'גוש',
          helka: 'חלקה',
          areaSqm: 'שטח (מ"ר)',
          migrash: 'מגרש',
          coordinates: 'נ״צ',
          designationXplan: 'ייעוד (XPLAN)',
        },
        blocks: {
          relatedPlans: 'תוכניות קשורות לקרקע',
          areaNotes: 'הערות שטח',
          lotSummary: 'סיכום מגרש',
          tableA: 'טבלה א׳ — זכויות והוראות בנייה',
          tableB: 'טבלה ב׳ — חניה וקווי בניין',
          editorRole: 'תפקיד עורך',
          editorName: 'שם עורך',
          phone: 'טלפון',
          fax: 'פקס',
          address: 'כתובת',
          approver: 'מאשר',
          approverPhone: 'טלפון מאשר',
          xplanLines: 'תכניות מקוונות (קווים כחולים / ייעוד XPLAN)',
          takanonExtracted: 'מתוך התקנון (קריאה אוטומטית)',
          takanonDraftNote: 'טיוטה — לא אומת. יש לבדוק מול התקנון המקורי.',
        },
        columns: {
          parcelGush: 'גוש',
          parcelHelkaSource: 'חלקת מקור',
          parcelAreaSqm: 'שטח חלקה רשום (מ"ר)',
          planNumber: 'מספר תוכנית',
          planName: 'שם',
          planNumberShort: "מס' תוכנית",
          lot: 'מגרש',
          planType: 'סוג תוכנית',
          planStatus: 'סטטוס',
          planDesignation: 'ייעוד בתוכנית',
          note: 'הערה',
        },
        sectionTitles: {
          landDetails: 'פרטי הקרקע',
          relatedPlans: 'תוכניות הנוגעות לקרקע',
          rights: 'זכויות והגבלות בנייה',
          notes: 'הערות',
        },
        categories: {
          designation: 'ייעוד ושימושים',
          parking: 'חניה',
        },
        topics: {
          parkingStandard: 'תקן חניה',
        },
        sources: {
          fixture: 'נתוני הדגמה (פיתוח מקומי)',
          xplan: 'מינהל התכנון (XPLAN)',
          vgm: 'VGM / Complot (legacy)',
          gisnet: 'GIS-Net דוח 33 (legacy)',
          gisnet_partial: 'GIS-Net (חלקי)',
          layers: 'הרכבה משכבות GIS (fallback)',
          map_identify: 'שכבת מפה בלבד',
        },
      },
    },
  },
  en: {
    appTitle: 'Clicks Tourism 360',
    branding: {
      poweredBy: 'Powered by',
      companyName: 'Clicks Strategic Ecosystems',
    },
    landing: {
      eyebrow: 'Entrepreneur portal · Eastern Galilee',
      title: 'Tourism parcel suitability check',
      subtitle:
        'Pick a parcel, get land availability and planning info, then enter entrepreneur details to open a file.',
      stepsHeading: 'What you get',
      onboardAria: 'Assessment steps',
      steps: [
        {
          title: 'Parcel selection',
          description: 'Land designation, plans, and lot number on the compilation map',
        },
        {
          title: 'Land availability & planning info',
          description: 'Traffic-light suitability and Form 119 report — before entrepreneur details',
        },
        {
          title: 'Entrepreneur details',
          description: 'Venture, contact, and consent to open the monday intake file',
        },
      ],
      startCta: 'Start check',
      startWizard: 'Start assessment',
      starting: 'Starting session…',
      startError: 'Could not start right now. Please try again.',
      intakeSuccessTitle: 'Entrepreneur file opened successfully',
      intakeSuccessBody: 'You can start a new check using the button below.',
      privacyLink: 'Privacy and data use',
      privacyHref: '/docs/entrepreneur/assessment',
      eshkolLogoAlt: 'Eshkol Eastern Galilee',
    },
    wizard: {
      title: 'Parcel assessment wizard',
      subtitle: 'Enter venture details, planning lot (migrash), and map location (Eastern Galilee only)',
      journeySubtitle: 'Entrepreneur details — after land availability and planning info',
      stepperAria: 'Questionnaire steps',
      journeyStepperAria: 'Check progress',
      journeyCompletedLabel: 'Completed:',
      journeySteps: {
        map: 'Parcel selection',
        assessment: 'Assessment & planning info',
      },
      journeyStepsCompact: {
        map: 'Parcel',
        assessment: 'Signal',
      },
      intakePhaseTitle: 'Entrepreneur details',
      intakeStepProgress: '{step} · Step {current} of {total}',
      navAria: 'Wizard navigation',
      back: 'Back',
      next: 'Continue',
      finish: 'Accept and continue',
      finishing: 'Saving and continuing…',
      errorTitle: 'Error',
      completeTitle: 'Questionnaire complete',
      completeBody:
        'Thank you! Your parcel from step 1 will be confirmed automatically. You will only see the map again if we need you to re-confirm.',
      steps: {
        venture: 'Venture details',
        contact: 'Contact',
        review: 'Review',
        consent: 'Consent',
      },
      fields: {
        ventureType: 'Venture type',
        ventureTypePlaceholder: 'Select venture type',
        requiredArea: 'Required area (sqm)',
        requiredAreaPlaceholder: 'e.g. 1200',
        timeline: 'Timeline',
        timelinePlaceholder: 'Select timeline',
        contactName: 'Full name',
        contactNamePlaceholder: 'Your name',
        contactPhone: 'Phone',
        contactPhonePlaceholder: '501234567',
        contactPhonePrefix: 'Country code',
        contactEmail: 'Email',
        contactEmailPlaceholder: 'name@example.com',
        parcelSection: 'Parcel location (compilation layer)',
        migrash: 'Planning lot (migrash)',
        migrashPlaceholder: 'e.g. 2145 (statutory plan)',
        mapLocation: 'Map location',
        mapHint:
          'Click a lot boundary on the compilation layer or enter the migrash number — Eastern Galilee only',
        mapAriaLabel: 'Eastern Galilee map for location selection',
        mapSelectedPrefix: 'Selected point:',
      },
      ventureTypes: {
        hotel: 'Hotel',
        bnb: 'B&B / guest rooms',
        glamping: 'Glamping',
        commercial_tourism: 'Commercial tourism',
        other: 'Other',
      },
      timelines: {
        immediate: 'Immediate (within 3 months)',
        within_6_months: 'Within 6 months',
        within_1_year: 'Within 1 year',
        exploring: 'Exploring / flexible',
      },
      units: {
        sqm: 'sqm',
      },
      reviewIntro: 'Review your details before consent.',
      reviewVentureSection: 'Venture',
      reviewContactSection: 'Contact',
      validation: {
        ventureTypeRequired: 'Please select a venture type',
        requiredAreaRequired: 'Please enter a positive area in sqm',
        timelineRequired: 'Please select a timeline',
        migrashRequired: 'Please enter a planning lot (migrash) number',
        migrashInvalid: 'Invalid migrash number',
        mapLocationRequired: 'Please click a lot on the map or enter a valid migrash',
        mapIdentifyFailed: 'No planning lot at this point — click inside a compilation lot boundary',
        contactNameRequired: 'Please enter your name',
        contactPhoneInvalid: 'Invalid phone number',
        contactEmailInvalid: 'Invalid email address',
        consentRequired: 'You must accept the disclaimer to continue',
      },
      consent: {
        noticeTitle: 'Important notice',
        noticeBody:
          'Information on this site is for preliminary suitability only and is not a planning approval, permit, or authority commitment.',
        savingHint: 'Saving your consent — this may take a few seconds.',
        checklistTitle: 'Confirm all items to continue:',
        checklistItems: {
          informational:
            'I understand the information is for preliminary suitability only and is not a planning approval or permit',
          dataProcessing:
            'I agree to processing my contact details and submitted data for parcel review and entrepreneur file opening',
          layers:
            'I understand planning data comes from public GIS layers (compilation, XPLAN) and may be partial',
        },
        checkboxLabel:
          'I understand the check is informational only and does not guarantee a permit',
        checkboxAria: 'Accept disclaimer',
        openFileTitle: 'Confirm and open entrepreneur file',
        openFileConfirm:
          'I reviewed the information above and request to open an entrepreneur file in the system',
        submitConfirmRequired: 'Please confirm before submitting',
        submit: 'Open entrepreneur file',
        submitLoading: 'Submitting file…',
        submitSuccess: 'File opened successfully',
        submitError: 'Could not open the file',
        submitProfileRequired: 'Please complete entrepreneur details before submitting',
      },
    },
    langSelect: {
      languageLabel: 'Language',
      hebrew: 'עברית',
      english: 'English',
      arabic: 'العربية',
      russian: 'Русский',
      chooseLanguageAria: 'Choose language',
    },
    header: {
      docs: 'User guide',
    },
    map: {
      title: 'Select parcel',
      subtitle: 'Click a colored land-designation area on the compilation map — Eastern Galilee only',
      searchLabel: 'Search migrash',
      hint: 'Click a colored compilation polygon — designation and plans appear on the next steps',
      clickToSelect: 'Click on map',
      drawPolygon: 'Draw parcel',
      selectionModeGroupLabel: 'How to select a parcel on the map',
      drawHint: 'Draw the parcel boundary on the map — click vertices, double-click to close',
      clearDrawing: 'Clear drawing',
      drawnAreaLabel: 'Marked area',
      layers: {
        title: 'Planning layers',
        migrashNote:
          'There is no separate public migrash polygon layer on XPLAN. Migrash comes from GIS-Net (if enabled) or manual entry. Toggle statutory plans for context.',
      },
      mapAriaLabel: 'Eastern Galilee map for parcel selection',
      expandMap: 'Expand map',
      collapseMap: 'Collapse map',
      layersLoading: 'Loading land-designation layer…',
      confirmTitle: 'Confirm location',
      confirmBody:
        'Location selected. Designation and plans will appear on the quick assessment and planning info pages.',
      confirmButton: 'Confirm parcel',
      confirmButtonLoading: 'Saving parcel…',
      completeTitle: 'Parcel saved',
      completeBody: 'Your parcel selection was saved. Assessment comes next (soon).',
      errorTitle: 'Error',
      fields: {
        migrash: 'Planning lot (migrash)',
        migrashPlaceholder: 'e.g. 2145 (statutory plan)',
        migrashEnterHint:
          'Planning lot (migrash): enter the committee lot number — not the cadastral gush/helka',
        cadastralRef: 'Gush/helka (cadastral, reference)',
        settlement: 'Settlement',
        designation: 'Designation',
        planPrimary: 'Primary plan',
        plansAffecting: 'Plans in area',
        plansAtPoint: 'Plans at click (blue lines)',
        area: 'Registered area',
        coordinates: 'Coordinates',
      },
      validation: {
        identifyFailed: 'No planning lot at this point — click a compilation lot boundary',
        identifyTimeout: 'Designation lookup took too long — try again or pick another spot',
        lookupFailed: 'No lot found — check the migrash number',
        cadastralLookupFailed: 'Cadastral parcel not found — check gush/helka',
      },
      legend: {
        title: 'Legend',
        loading: 'Loading legend from XPlan compilation…',
        loadError: 'Could not load legend — refresh the page',
        summaryHint: 'Key tourism classes — click a colored area on the map',
        showFull: 'Full legend ({count})',
        mapFilterOpen: 'Filter designations on map ({count})',
        mapFilterActive: 'Shown on map: {shown}/{total}',
        mapFilterTitle: 'Land designations on map — {layer}',
        mapFilterIntro: 'Choose which designations appear on the compilation layer. Changes apply immediately.',
        mapVisibleMeta: '{shown} of {total} designations shown on the map',
        selectAll: 'Show all',
        selectTourism: 'Tourism only',
        selectNone: 'Hide all',
        fullTitle: 'Legend — {layer}',
        fullMeta: '{count} classes on the XPlan compilation layer',
        filteredMeta: '{shown} of {total} classes',
        filterLabel: 'Search list',
        filterPlaceholder: 'Search designation (e.g. tourism, recreation, rural…)',
        filterEmpty: 'No matching classes — try another term',
        close: 'Close',
        approvalDateHint: 'Plan approval date appears on the planning info page (§2)',
      },
    },
    assessment: {
      title: 'Parcel suitability assessment',
      combinedTitle: 'Land availability & planning info',
      combinedSubtitle:
        'Suitability signal first, then the planning report — not a permit approval',
      statusRevealLoading: 'Checking land availability…',
      statusRevealHint: 'Analyzing designation and loading the planning report',
      continueToQuestionnaire: 'Enter entrepreneur details',
      continueToQuestionnaireHint: 'After completing details you can open the intake file',
      finishJourney: 'Finish',
      finishJourneyHint: 'Return home — your intake file was opened successfully',
      ctaWaitingForReport: 'Available once the planning report has loaded',
      subtitle:
        'Quick check from compilation-layer land designation — not a permit approval',
      loading: 'Loading assessment…',
      errorTitle: 'Error',
      designationTitle: 'Land designation',
      detailsTitle: 'Assessment details',
      ctaHint: 'Optional step — full Tabo 119 report (slower load)',
      trafficLight: {
        green: 'Green — tourism',
        yellow: 'Yellow — maybe (residential / agricultural / urban)',
        red: 'Red — nature reserve, roads',
        unknown: 'Not classified on map',
      },
      viewPlanningInfo: 'Full planning info',
      verdictTitle: 'Verdict',
      verdict: {
        yes: 'Yes',
        no: 'No',
        conditional: 'Conditional',
        unknown: 'Unknown',
      },
      submit: 'Open entrepreneur file',
      submitLoading: 'Submitting file…',
      submitSuccess: 'File opened successfully',
      submitError: 'Could not open file',
      submitPlaceholder: 'Open entrepreneur file (coming soon)',
      unknownNote: 'We could not assess this parcel — committee staff will follow up.',
      status: {
        available: 'Suitable',
        conditional: 'Conditionally suitable',
        unlikely: 'Low likelihood',
        unknown: 'Unknown',
      },
      rules: {
        pass: 'Pass',
        fail: 'Fail',
        skip: 'Skipped',
      },
    },
    planningInfo: {
      title: 'Planning info — Amendment 119',
      ramzorLabel: 'Suitability check',
      subtitle: 'Planning summary from map pick and XPLAN plans (compilation layer)',
      loading: 'Loading planning info…',
      reportLoading: 'Loading planning report and extracting rights from takanon…',
      errorTitle: 'Error',
      disclaimerTitle: 'Important notice',
      disclaimerBody:
        'This page is a structured planning summary for preliminary suitability only. It is not a planning approval, building permit, or authority commitment. For a formal request, use the VGM system.',
      lineageFooter: 'Data source: XPLAN (Planning Administration), GovMap cadastral.',
      reportDate: 'Report date',
      requestType: 'Request type',
      section1Title: '1. Land details',
      section2Title: '2. Related plans',
      section3Title: '3. Building rights and restrictions',
      section4Title: '4. Notes',
      missingSession: 'Missing session',
      exportPrintFallback:
        'PDF export unavailable — print preview opened; use Print → Save as PDF.',
      openXplanLink: 'Open XPLAN (Planning Administration)',
      xplanLineage: 'Plans and designation from XPLAN; not a local committee Amendment 119 report.',
      xplanFallbackNote:
        'XPLAN data did not load — pick a parcel on the map (centroid required). You can open XPLAN directly.',
      openOfficialReport: 'Open XPLAN',
      vgmMatchNote: '',
      officialVgmLink: 'XPLAN',
      fetchStatus: {
        complete: '',
        partial: 'Some data is unavailable — showing a partial summary.',
        failed: 'Could not load full planning information.',
      },
      documentsTitle: 'Official documents (takanon)',
      documentsEmpty: 'Takanon link unavailable — try again later.',
      takanonNotFoundTitle: 'Takanon document not found',
      takanonNotFoundBody:
        'We could not find a takanon document for this plan. Showing land details and plans from XPLAN only.',
      expandTakanonRights: 'Expand rights from takanon',
      expandTakanonLoading: 'Extracting rights from takanon…',
      extractionBannerTitle: 'Partial takanon extraction',
      extractionBannerBody:
        'Some building rights were not extracted. Showing XPLAN §1–§2 and link to the source PDF.',
      extractionNotice:
        'Values from automated takanon reading — verify against the official source.',
      extractionSectionDraftNotice:
        'Values from automated reading — not verified against the takanon.',
      extractionDraftBannerTitle: 'Takanon extraction — draft',
      extractionDraftBannerBody:
        'Values from automated reading — not verified against the takanon (Sprint 7).',
      verifySource: 'Verify against source',
      openPdfOnPage: 'Open PDF on page',
      lowConfidence: 'low confidence',
      submitTitle: 'Confirm and open entrepreneur file',
      submitConfirm: 'I reviewed the information above and request to open an entrepreneur file',
      submitConfirmRequired: 'Please confirm before submitting',
      submitProfileIntro:
        'Before opening the monday item, enter entrepreneur details (even if you skipped the questionnaire):',
      submitProfileRequired: 'Entrepreneur name and venture type are required',
      submit: 'Open entrepreneur file',
      submitLoading: 'Submitting file…',
      submitSuccess: 'File opened successfully',
      submitError: 'Could not open file',
      exportPdf: 'Export PDF',
      exportingPdf: 'Exporting PDF…',
      exportPdfError: 'Could not export PDF. Please try again.',
      pdfProducedBy: 'Produced by Clicks Strategic Ecosystems',
      pdfPage: 'Page',
      pdfProductName: 'Clicks Tourism 360',
      pdfProductTagline: 'Planning intelligence — Eastern Galilee',
      reportCoverSubtitle: 'Structured planning report for the selected parcel',
      reportInformationalNotice:
        'This report is a planning summary for preliminary suitability only — not a planning approval, building permit, or authority commitment.',
      reportDocumentRef: 'Document ID',
      reportSourceLabel: 'Data source',
      report: {
        coverBadge: 'Amendment 119',
        parcelCadastralLine: 'Block {gush} / Parcel {helka}',
        fields: {
          settlement: 'Settlement',
          gush: 'Block (gush)',
          helka: 'Parcel (helka)',
          areaSqm: 'Area (sqm)',
          migrash: 'Planning lot (migrash)',
          coordinates: 'Coordinates (lng, lat)',
          designationXplan: 'Designation (XPLAN)',
        },
        blocks: {
          relatedPlans: 'Plans related to the parcel',
          areaNotes: 'Area notes',
          lotSummary: 'Lot summary',
          tableA: 'Table A — building rights and instructions',
          tableB: 'Table B — parking and building lines',
          editorRole: 'Editor role',
          editorName: 'Editor name',
          phone: 'Phone',
          fax: 'Fax',
          address: 'Address',
          approver: 'Approver',
          approverPhone: 'Approver phone',
          xplanLines: 'Statutory plans (blue lines / XPLAN designation)',
          takanonExtracted: 'From takanon (automated read)',
          takanonDraftNote:
            'Values from automated takanon reading — verify against the official source.',
        },
        columns: {
          parcelGush: 'Block (gush)',
          parcelHelkaSource: 'Source parcel',
          parcelAreaSqm: 'Registered parcel area (sqm)',
          planNumber: 'Plan number',
          planName: 'Name',
          planNumberShort: 'Plan no.',
          lot: 'Lot',
          planType: 'Plan type',
          planStatus: 'Status',
          planDesignation: 'Designation in plan',
          note: 'Note',
        },
        sectionTitles: {
          landDetails: 'Land details',
          relatedPlans: 'Related plans',
          rights: 'Building rights and restrictions',
          notes: 'Notes',
        },
        categories: {
          designation: 'Designation and uses',
          parking: 'Parking',
        },
        topics: {
          parkingStandard: 'Parking standard',
        },
        sources: {
          fixture: 'Demo data (local development)',
          xplan: 'Planning Administration (XPLAN)',
          vgm: 'VGM / Complot (legacy)',
          gisnet: 'GIS-Net report 33 (legacy)',
          gisnet_partial: 'GIS-Net (partial)',
          layers: 'GIS layer assembly (fallback)',
          map_identify: 'Map layer only',
        },
      },
    },
  },
  ar: {
    appTitle: 'Clicks Tourism 360',
    branding: {
      poweredBy: 'بدعم من',
      companyName: 'Clicks Strategic Ecosystems',
    },
    landing: {
      eyebrow: 'بوابة رواد الأعمال · الجليل الشرقي',
      title: 'فحص ملاءمة قطعة للسياحة',
      subtitle:
        'اخترُوا قطعة على الخريطة، واحصلوا على إشارة ملاءمة أولية وصفحة معلومات تخطيطية — قبل فتح ملف رسمي لدى السلطة.',
      stepsHeading: 'ماذا تحصلون في المسار',
      onboardAria: 'خطوات الفحص',
      steps: [
        {
          title: 'اختيار القطعة',
          description: 'تصنيف الأرض والخطط ورقم القطعة على خريطة التجميع',
        },
        {
          title: 'تقييم توفر الأرض والمعلومات التخطيطية',
          description: 'إشارة الملاءمة وتقرير 119 — قبل بيانات رائد الأعمال',
        },
        {
          title: 'بيانات رائد الأعمال',
          description: 'تفاصيل المشروع والاتصال والموافقة لفتح الملف',
        },
      ],
      startCta: 'بدء الفحص',
      startWizard: 'بدء الفحص',
      starting: 'جاري فتح الجلسة…',
      startError: 'تعذّر البدء حاليًا. يُرجى المحاولة مرة أخرى.',
      intakeSuccessTitle: 'تم فتح ملف رائد الأعمال بنجاح',
      intakeSuccessBody: 'يمكنكم بدء فحص جديد بالضغط على الزر أدناه.',
      privacyLink: 'الخصوصية واستخدام البيانات',
      privacyHref: '/docs/entrepreneur/assessment',
      eshkolLogoAlt: 'إشكول الجليل الشرقي',
    },
    wizard: {
      title: 'مسار فحص القطعة',
      subtitle: 'أدخلوا تفاصيل المشروع ورقم قطعة التخطيط (מגרש) والموقع على الخريطة (الجليل الشرقي فقط)',
      journeySubtitle: 'بيانات رائد الأعمال — بعد تقييم توفر الأرض والمعلومات التخطيطية',
      stepperAria: 'خطوات الاستبيان',
      journeyStepperAria: 'تقدم المسار',
      journeyCompletedLabel: 'مكتمل:',
      journeySteps: {
        map: 'اختيار القطعة',
        assessment: 'التقييم والمعلومات التخطيطية',
      },
      journeyStepsCompact: {
        map: 'قطعة',
        assessment: 'إشارة',
      },
      intakePhaseTitle: 'بيانات رائد الأعمال',
      intakeStepProgress: '{step} · الخطوة {current} من {total}',
      navAria: 'التنقل في الاستبيان',
      back: 'رجوع',
      next: 'متابعة',
      finish: 'تأكيد ومتابعة',
      finishing: 'جاري الحفظ والمتابعة…',
      errorTitle: 'خطأ',
      completeTitle: 'اكتمل الاستبيان',
      completeBody:
        'شكرًا لكم! ستُؤكَّد القطعة التي اخترتموها في خطوة تفاصيل المشروع تلقائيًا. ستظهر الخريطة فقط إذا طُلب منكم إعادة التأكيد.',
      steps: {
        venture: 'تفاصيل المشروع',
        contact: 'التواصل',
        review: 'ملخص',
        consent: 'الموافقة',
      },
      fields: {
        ventureType: 'نوع المشروع',
        ventureTypePlaceholder: 'اختر نوع المشروع',
        requiredArea: 'المساحة المطلوبة (م²)',
        requiredAreaPlaceholder: 'مثال: 1200',
        timeline: 'الجدول الزمني',
        timelinePlaceholder: 'اختر الجدول الزمني',
        contactName: 'الاسم الكامل',
        contactNamePlaceholder: 'اسم رائد الأعمال',
        contactPhone: 'الهاتف',
        contactPhonePlaceholder: '501234567',
        contactPhonePrefix: 'رمز الدولة',
        contactEmail: 'البريد الإلكتروني',
        contactEmailPlaceholder: 'name@example.com',
        parcelSection: 'موقع القطعة (طبقة التجميع)',
        migrash: 'رقم قطعة التخطيط (מגרש)',
        migrashPlaceholder: 'مثال: 2145 (من الخطة المعتمدة)',
        mapLocation: 'الموقع على الخريطة',
        mapHint:
          'انقروا على حدود قطعة في الخريطة (طبقة الاستخدام / التجميع) أو أدخلوا رقم القطعة — الجليل الشرقي فقط',
        mapAriaLabel: 'خريطة الجليل الشرقي لاختيار الموقع',
        mapSelectedPrefix: 'النقطة المختارة:',
      },
      ventureTypes: {
        hotel: 'فندق',
        bnb: 'غرف ضيافة / B&B',
        glamping: 'تخييم فاخر',
        commercial_tourism: 'سياحة تجارية',
        other: 'أخرى',
      },
      timelines: {
        immediate: 'فوري (حتى 3 أشهر)',
        within_6_months: 'حتى 6 أشهر',
        within_1_year: 'حتى سنة',
        exploring: 'مرحلة استكشاف / بدون جدول ثابت',
      },
      units: {
        sqm: 'م²',
      },
      reviewIntro: 'تحققوا من صحة البيانات قبل المتابعة إلى التأكيد والموافقة.',
      reviewVentureSection: 'تفاصيل المشروع',
      reviewContactSection: 'بيانات التواصل',
      validation: {
        ventureTypeRequired: 'يُرجى اختيار نوع المشروع',
        requiredAreaRequired: 'يُرجى إدخال مساحة موجبة بالمتر المربع',
        timelineRequired: 'يُرجى اختيار الجدول الزمني',
        migrashRequired: 'يُرجى إدخال رقم قطعة التخطيط',
        migrashInvalid: 'رقم قطعة التخطيط غير صالح',
        mapLocationRequired: 'يُرجى النقر على قطعة في الخريطة أو إدخال رقم قطعة صالح',
        mapIdentifyFailed: 'لم تُعثر على قطعة في هذه النقطة — انقروا على حدود قطعة في طبقة التجميع',
        contactNameRequired: 'يُرجى إدخال الاسم',
        contactPhoneInvalid: 'رقم الهاتف غير صالح',
        contactEmailInvalid: 'عنوان البريد الإلكتروني غير صالح',
        consentRequired: 'يجب الموافقة على الإقرار للمتابعة',
      },
      consent: {
        noticeTitle: 'إشعار مهم',
        noticeBody:
          'المعلومات في الموقع مخصّصة للملاءمة الأولية فقط ولا تُعدّ موافقة تخطيطية أو تصريحًا أو التزامًا من الجهة المختصة.',
        savingHint: 'جاري حفظ الموافقة — قد يستغرق ذلك بضع ثوانٍ.',
        checklistTitle: 'يجب تأكيد جميع البنود للمتابعة:',
        checklistItems: {
          informational:
            'أفهم أن المعلومات للملاءمة الأولية فقط وليست موافقة تخطيطية أو تصريحًا',
          dataProcessing:
            'أوافق على معالجة بيانات الاتصال والمعلومات المقدّمة لمراجعة القطعة وفتح ملف رائد الأعمال',
          layers:
            'أفهم أن البيانات التخطيطية من طبقات GIS العامة (التجميع، XPLAN) وقد تكون جزئية',
        },
        checkboxLabel:
          'قرأتُ وفهمتُ أن الفحص إعلامي فقط ولا يضمن الحصول على تصريح',
        checkboxAria: 'الموافقة على إخلاء المسؤولية',
        openFileTitle: 'تأكيد وفتح ملف رائد الأعمال',
        openFileConfirm:
          'أؤكد أنني راجعت المعلومات أعلاه وأطلب فتح ملف رائد أعمال في النظام',
        submitConfirmRequired: 'يرجى تأكيد الطلب قبل الإرسال',
        submit: 'فتح ملف رائد الأعمال',
        submitLoading: 'جاري إرسال الملف…',
        submitSuccess: 'تم فتح الملف بنجاح',
        submitError: 'تعذر فتح الملف',
        submitProfileRequired: 'يرجى إكمال بيانات رائد الأعمال قبل الإرسال',
      },
    },
    langSelect: {
      languageLabel: 'اللغة',
      hebrew: 'עברית',
      english: 'English',
      arabic: 'العربية',
      russian: 'Русский',
      chooseLanguageAria: 'اختيار اللغة',
    },
    header: {
      docs: 'دليل المستخدم',
    },
    map: {
      title: 'اختيار القطعة',
      subtitle: 'انقروا على منطقة ملونة في خريطة ייעודי קרקע (קומפילציה) — الجليل الشرقي فقط',
      searchLabel: 'البحث عن قطعة',
      hint: 'انقروا على مضلع ملون — الاستخدام والخطط تظهر في الخطوة التالية',
      clickToSelect: 'النقر على الخريطة',
      drawPolygon: 'رسم قطعة',
      selectionModeGroupLabel: 'طريقة اختيار القطعة على الخريطة',
      drawHint: 'ارسموا حدود القطعة على الخريطة',
      clearDrawing: 'مسح الرسم',
      drawnAreaLabel: 'مساحة محددة',
      layers: {
        title: 'שכבות תכנון',
        migrashNote:
          'لا توجد שכבת מגרשים נפרדת ב-XPLAN العام. رقم המגרש من GIS-Net (إن وُجد) أو إدخال يدوي.',
      },
      mapAriaLabel: 'خريطة الجليل الشرقي لاختيار القطعة',
      expandMap: 'تكبير الخريطة',
      collapseMap: 'تصغير الخريطة',
      layersLoading: 'جارٍ تحميل طبقة تصنيف الأراضي…',
      confirmTitle: 'تأكيد الموقع',
      confirmBody:
        'تم اختيار الموقع. الاستخدام والخطط ستظهر في فحص الملاءمة وصفحة المعلومات التخطيطية.',
      confirmButton: 'تأكيد القطعة',
      confirmButtonLoading: 'جارٍ حفظ القطعة…',
      completeTitle: 'تم حفظ القطعة',
      completeBody: 'تم حفظ اختيار القطعة. في الخطوة التالية ستُعرض فحص الملاءمة (قريبًا).',
      errorTitle: 'خطأ',
      fields: {
        migrash: 'رقم قطعة التخطيط (מגרש)',
        migrashPlaceholder: 'مثال: 2145 (من الخطة المعتمدة)',
        migrashEnterHint:
          'رقم قطعة التخطيط: أدخلوا رقم المגרש من اللجنة — ليس هوية السجل (גוש/חלקה)',
        cadastralRef: 'بلوك/قطعة (سجل، للاطلاع)',
        settlement: 'البلدة',
        designation: 'الاستخدام',
        planPrimary: 'الخطة الرئيسية',
        plansAffecting: 'خطط في المنطقة',
        plansAtPoint: 'خطط عند النقرة',
        area: 'المساحة المسجّلة',
        coordinates: 'إحداثيات',
      },
      validation: {
        identifyFailed: 'لم تُعثر على قطعة في هذه النقطة — انقروا على حدود قطعة في طبقة التجميع',
        identifyTimeout: 'استغرق تحديد التصنيف وقتاً طويلاً — حاولوا مرة أخرى أو اختاروا نقطة أخرى',
        lookupFailed: 'لم تُعثر على قطعة — تحققوا من رقم القطعة',
        cadastralLookupFailed: 'لم تُعثر على قطعة في السجل — تحققوا من גוש/חלקה',
      },
      legend: {
        title: 'مفتاح الخريطة',
        loading: 'جاري تحميل المفتاح من XPlan…',
        loadError: 'تعذر تحميل المفتاح — حدّث الصفحة',
        summaryHint: 'تصنيفات سياحية رئيسية — انقر على منطقة ملونة على الخريطة',
        showFull: 'مفتاح كامل ({count})',
        mapFilterOpen: 'تصفية ייעודים على الخريطة ({count})',
        mapFilterActive: 'على الخريطة: {shown}/{total}',
        mapFilterTitle: 'ייעודי קרקע على الخريطة — {layer}',
        mapFilterIntro: 'حدّدوا אילו ייעודים تוצגו בשכבת הקומפילציה. التغيير فوري.',
        mapVisibleMeta: '{shown} من {total} ייעודים على الخريطة',
        selectAll: 'إظهار الكل',
        selectTourism: 'سياحة فقط',
        selectNone: 'إخفاء الكل',
        fullTitle: 'مفتاح — {layer}',
        fullMeta: '{count} تصنيفات في طبقة التجميع (XPlan)',
        filteredMeta: '{shown} من {total} تصنيفات',
        filterLabel: 'تصفية حسب يיעוד קרקע',
        filterPlaceholder: 'بحث عن ייעוד (مثلاً سياحة، نزهة، ريفي…)',
        filterEmpty: 'لا توجد تصنيفات مطابقة',
        close: 'إغلاق',
        approvalDateHint: 'تاريخ اعتماد الخطة يظهر في صفحة المعلومات التخطيطية (§2)',
      },
    },
    assessment: {
      title: 'فحص ملاءمة القطعة',
      combinedTitle: 'تقييم توفر الأرض والمعلومات التخطيطية',
      combinedSubtitle: 'إشارة الملاءمة أولاً ثم التقرير التخطيطي — ليس موافقة رسمية',
      statusRevealLoading: 'جاري فحص توفر الأرض…',
      statusRevealHint: 'تحليل التصنيف وتحميل التقرير التخطيطي',
      continueToQuestionnaire: 'إدخال بيانات رائد الأعمال',
      continueToQuestionnaireHint: 'بعد إكمال البيانات يمكن فتح ملف الاستقبال',
      finishJourney: 'إنهاء',
      finishJourneyHint: 'العودة للصفحة الرئيسية — تم فتح ملف الاستقبال بنجاح',
      ctaWaitingForReport: 'يُفعَّل الزر بعد تحميل التقرير التخطيطي',
      subtitle: 'تقييم سريع حسب استخدام الأرض في طبقة التجميع — لا يُعدّ موافقة على تصريح',
      loading: 'جاري تحميل تقييم الملاءمة…',
      errorTitle: 'خطأ',
      designationTitle: 'ייעוד קרקע:',
      detailsTitle: 'تفاصيل التقييم',
      ctaHint: 'خطوة اختيارية — تقرير التعديل 119 الكامل (تحميل أبطأ)',
      trafficLight: {
        green: 'أخضر — سياحة',
        yellow: 'أصفر — ربما (سكن / زراعة / حضري)',
        red: 'أحمر — محمية طبيعية، طرق',
        unknown: 'غير مصنّف على الخريطة',
      },
      viewPlanningInfo: 'عرض المعلومات التخطيطية الكاملة',
      submit: 'فتح ملف رائد الأعمال',
      submitLoading: 'جاري إرسال الملف…',
      submitSuccess: 'تم فتح الملف بنجاح',
      submitError: 'تعذّر فتح الملف',
      submitPlaceholder: 'فتح ملف رائد الأعمال (قريبًا)',
      unknownNote: 'تعذّر تقييم القطعة حاليًا — سيتواصل معكم موظف اللجنة بعد المراجعة.',
      status: {
        available: 'مناسب — أخضر',
        conditional: 'مناسب بشروط — أصفر',
        unlikely: 'احتمال منخفض — أحمر',
        unknown: 'غير معروف — يتطلب مراجعة',
      },
      rules: {
        pass: 'نجح',
        fail: 'فشل',
        skip: 'غير ذي صلة',
      },
    },
    planningInfo: {
      title: 'معلومات تخطيطية — التعديل 119',
      ramzorLabel: 'فحص الملاءمة',
      subtitle: 'ملخص المعلومات التخطيطية للقطعة المختارة',
      loading: 'جاري تحميل المعلومات التخطيطية…',
      reportLoading: 'جاري تحميل التقرير واستخراج الحقوق من التקנון…',
      errorTitle: 'خطأ',
      disclaimerTitle: 'إشعار مهم',
      disclaimerBody:
        'المعلومات المعروضة هنا ملخص تخطيطي للملاءمة الأولية فقط. لا تُعدّ موافقة تخطيطية أو تصريح بناء أو التزامًا من الجهة المختصة. للطلب الرسمي، راجعوا نظام VGM.',
      lineageFooter: 'مصدر البيانات: XPLAN (إدارة التخطيط)، GovMap للسجل العقاري. قد تتغيّر المعلومات.',
      reportDate: 'تاريخ التقرير',
      requestType: 'نوع الطلب',
      section1Title: '1. تفاصيل الأرض',
      section2Title: '2. الخطط المتعلقة بالأرض',
      section3Title: '3. حقوق البناء والقيود',
      section4Title: '4. ملاحظات',
      missingSession: 'معرّف الجلسة مفقود',
      exportPrintFallback:
        'تعذّر تصدير PDF — فُتحت معاينة الطباعة؛ اختاروا طباعة → حفظ كـ PDF.',
      openXplanLink: 'فتح XPLAN (إدارة التخطيط)',
      xplanLineage: 'الخطط والاستخدام من XPLAN؛ ليس تقرير التعديل 119 للجنة المحلية.',
      xplanFallbackNote:
        'لم تُحمَّل بيانات XPLAN — تأكدوا من اختيار قطعة على الخريطة (مطلوب مركز جغرافي). يمكنكم فتح XPLAN مباشرة.',
      openOfficialReport: 'فتح XPLAN',
      vgmMatchNote: '',
      officialVgmLink: 'XPLAN',
      fetchStatus: {
        complete: '',
        partial: 'بعض البيانات غير متاحة — يُعرض ملخص جزئي.',
        failed: 'تعذّر تحميل جميع المعلومات التخطيطية.',
      },
      documentsTitle: 'مستندات رسمية (التקנון)',
      documentsEmpty: 'رابط التקנון غير متاح — حاولوا لاحقًا.',
      takanonNotFoundTitle: 'لم يُعثر على مستند التקنון',
      takanonNotFoundBody:
        'لم نتمكن من العثور على مستند التקנון للخطة. يُعرض تفاصيل الأرض والخطط من XPLAN فقط.',
      expandTakanonRights: 'توسيع الحقوق من التקنון',
      expandTakanonLoading: 'جاري استخراج الحقوق من التקנון…',
      extractionBannerTitle: 'استخراج جزئي للتקנון',
      extractionBannerBody:
        'لم تُستخرج بعض حقوق البناء من التקנון. يُعرض §1–§2 من XPLAN ورابط للمستند الأصلي.',
      extractionNotice:
        'قيم من قراءة آلية للتקנון — يُرجى التحقق من المصدر الرسمي.',
      extractionSectionDraftNotice:
        'قيم من قراءة آلية — لم تُتحقق مقابل التקנון.',
      extractionDraftBannerTitle: 'التקנון — غير مُتحقق',
      extractionDraftBannerBody:
        'قيم من قراءة آلية — لم تُتحقق مقابل التקנון (Sprint 7).',
      verifySource: 'التحقق من المصدر',
      openPdfOnPage: 'فتح PDF في الصفحة',
      lowConfidence: 'ثقة منخفضة',
      submitTitle: 'تأكيد وفتح ملف رائد الأعمال',
      submitConfirm:
        'أؤكد/أؤكد أن المعلومات أعلاه رُاجعت وأطلب/أطلب فتح ملف رائد الأعمال في النظام',
      submitConfirmRequired: 'يرجى تأكيد الطلب قبل الإرسال',
      submitProfileIntro:
        'قبل فتح الملف في monday، يرجى إكمال بيانات رائد الأعمال (حتى إن تخطيتم خطوات الاستبيان):',
      submitProfileRequired: 'يرجى إدخال اسم رائد الأعمال ونوع المشروع',
      submit: 'فتح ملف رائد الأعمال',
      submitLoading: 'جاري إرسال الملف…',
      submitSuccess: 'تم فتح الملف بنجاح',
      submitError: 'تعذّر فتح الملف',
      exportPdf: 'تصدير PDF',
      exportingPdf: 'جاري تصدير PDF…',
      exportPdfError: 'تعذّر تصدير PDF. حاولوا مرة أخرى.',
      pdfProducedBy: 'Produced by Clicks Strategic Ecosystems',
      pdfPage: 'صفحة',
      pdfProductName: 'Clicks Tourism 360',
      pdfProductTagline: 'استخبارات تخطيطية — الجليل الشرقي',
      reportCoverSubtitle: 'تقرير معلومات تخطيطية منظم للقطعة المختارة',
      reportInformationalNotice:
        'هذا التقرير ملخص تخطيطي للملاءمة الأولية فقط — وليس موافقة تخطيطية أو تصريح بناء.',
      reportDocumentRef: 'معرّف المستند',
      reportSourceLabel: 'مصدر البيانات',
      report: {
        coverBadge: 'التعديل 119',
        parcelCadastralLine: 'بلوك {gush} / قطعة {helka}',
        fields: {
          settlement: 'البلدة',
          gush: 'البلوك (גוש)',
          helka: 'القطعة (חלקה)',
          areaSqm: 'المساحة (م²)',
          migrash: 'قطعة التخطيط (מגרש)',
          coordinates: 'إحداثيات (lng, lat)',
          designationXplan: 'الاستخدام (XPLAN)',
        },
        blocks: {
          relatedPlans: 'خطط مرتبطة بالأرض',
          areaNotes: 'ملاحظات المساحة',
          lotSummary: 'ملخص القطعة',
          tableA: 'الجدول أ — حقوق البناء والتعليمات',
          tableB: 'الجدول ب — مواقف وخطوط البناء',
          editorRole: 'دور المحرر',
          editorName: 'اسم المحرر',
          phone: 'الهاتف',
          fax: 'الفاكس',
          address: 'العنوان',
          approver: 'المعتمد',
          approverPhone: 'هاتف المعتمد',
          xplanLines: 'خطط تنظيمية (خطوط زرقاء / استخدام XPLAN)',
          takanonExtracted: 'من التקנון (قراءة آلية)',
          takanonDraftNote:
            'قيم من قراءة آلية للتקנון — يُرجى التحقق من المصدر الرسمي.',
        },
        columns: {
          parcelGush: 'البلوك (גוש)',
          parcelHelkaSource: 'قطعة المصدر',
          parcelAreaSqm: 'مساحة القطعة المسجّلة (م²)',
          planNumber: 'رقم الخطة',
          planName: 'الاسم',
          planNumberShort: 'رقم الخطة',
          lot: 'قطعة',
          planType: 'نوع الخطة',
          planStatus: 'الحالة',
          planDesignation: 'الاستخدام في الخطة',
          note: 'ملاحظة',
        },
        sectionTitles: {
          landDetails: 'تفاصيل الأرض',
          relatedPlans: 'خطط متعلقة بالأرض',
          rights: 'حقوق البناء والقيود',
          notes: 'ملاحظات',
        },
        categories: {
          designation: 'الاستخدام والتصنيفات',
          parking: 'مواقف السيارات',
        },
        topics: {
          parkingStandard: 'معيار المواقف',
        },
        sources: {
          fixture: 'بيانات تجريبية (تطوير محلي)',
          xplan: 'إدارة التخطيط (XPLAN)',
          vgm: 'VGM / Complot (قديم)',
          gisnet: 'GIS-Net تقرير 33 (قديم)',
          gisnet_partial: 'GIS-Net (جزئي)',
          layers: 'تجميع طبقات GIS (احتياطي)',
          map_identify: 'طبقة الخريطة فقط',
        },
      },
    },
  },
  ru: {
    appTitle: 'Clicks Tourism 360',
    branding: {
      poweredBy: 'При поддержке',
      companyName: 'Clicks Strategic Ecosystems',
    },
    landing: {
      eyebrow: 'Портал для предпринимателей · Восточная Галилея',
      title: 'Проверка участка на пригодность для туризма',
      subtitle:
        'Выберите участок на карте, получите первичный сигнал пригодности и при необходимости информационный лист — до открытия официального дела.',
      stepsHeading: 'Что вы получите',
      onboardAria: 'Шаги проверки',
      steps: [
        {
          title: 'Выбор участка',
          description: 'Назначение земли, планы и номер участка на карте компиляции',
        },
        {
          title: 'Доступность земли и планировочная информация',
          description: 'Сигнал пригодности и отчёт 119 — до данных предпринимателя',
        },
        {
          title: 'Данные предпринимателя',
          description: 'Проект, контакты и согласие на открытие дела',
        },
      ],
      startCta: 'Начать проверку',
      startWizard: 'Начать проверку',
      starting: 'Открываем сессию…',
      startError: 'Сейчас не удалось начать. Попробуйте ещё раз.',
      intakeSuccessTitle: 'Дело предпринимателя успешно открыто',
      intakeSuccessBody: 'Можно начать новую проверку кнопкой ниже.',
      privacyLink: 'Конфиденциальность и использование данных',
      privacyHref: '/docs/entrepreneur/assessment',
      eshkolLogoAlt: 'Эшколь Восточной Галилеи',
    },
    wizard: {
      title: 'Проверка участка',
      subtitle: 'Укажите данные проекта, номер планировочного участка (migrash) и место на карте (только Восточная Галилея)',
      journeySubtitle: 'Данные предпринимателя — после оценки доступности и планировочной информации',
      stepperAria: 'Шаги анкеты',
      journeyStepperAria: 'Прогресс проверки',
      journeyCompletedLabel: 'Завершено:',
      journeySteps: {
        map: 'Выбор участка',
        assessment: 'Оценка и планировочная информация',
      },
      journeyStepsCompact: {
        map: 'Участок',
        assessment: 'Сигнал',
      },
      intakePhaseTitle: 'Данные предпринимателя',
      intakeStepProgress: '{step} · Шаг {current} из {total}',
      navAria: 'Навигация по анкете',
      back: 'Назад',
      next: 'Далее',
      finish: 'Подтвердить и продолжить',
      finishing: 'Сохраняем и продолжаем…',
      errorTitle: 'Ошибка',
      completeTitle: 'Анкета завершена',
      completeBody:
        'Спасибо! Участок, выбранный на шаге с данными проекта, будет подтверждён автоматически. Карта появится снова только если потребуется повторное подтверждение.',
      steps: {
        venture: 'Данные проекта',
        contact: 'Контакты',
        review: 'Сводка',
        consent: 'Согласие',
      },
      fields: {
        ventureType: 'Тип проекта',
        ventureTypePlaceholder: 'Выберите тип проекта',
        requiredArea: 'Требуемая площадь (кв. м)',
        requiredAreaPlaceholder: 'например: 1200',
        timeline: 'Сроки',
        timelinePlaceholder: 'Выберите сроки',
        contactName: 'Полное имя',
        contactNamePlaceholder: 'Имя предпринимателя',
        contactPhone: 'Телефон',
        contactPhonePlaceholder: '501234567',
        contactPhonePrefix: 'Код страны',
        contactEmail: 'Эл. почта',
        contactEmailPlaceholder: 'name@example.com',
        parcelSection: 'Местоположение участка (слой компиляции)',
        migrash: 'Планировочный участок (migrash)',
        migrashPlaceholder: 'например: 2145 (из утверждённого плана)',
        mapLocation: 'Место на карте',
        mapHint:
          'Нажмите на границу участка на карте (слой назначения / компиляции) или введите номер migrash — только Восточная Галилея',
        mapAriaLabel: 'Карта Восточной Галилеи для выбора места',
        mapSelectedPrefix: 'Выбранная точка:',
      },
      ventureTypes: {
        hotel: 'Отель',
        bnb: 'B&B / гостевые номера',
        glamping: 'Глэмпинг',
        commercial_tourism: 'Коммерческий туризм',
        other: 'Другое',
      },
      timelines: {
        immediate: 'Срочно (до 3 месяцев)',
        within_6_months: 'До 6 месяцев',
        within_1_year: 'До года',
        exploring: 'На стадии изучения / без жёстких сроков',
      },
      units: {
        sqm: 'кв. м',
      },
      reviewIntro: 'Проверьте данные перед подтверждением и согласием.',
      reviewVentureSection: 'Данные проекта',
      reviewContactSection: 'Контакты',
      validation: {
        ventureTypeRequired: 'Выберите тип проекта',
        requiredAreaRequired: 'Укажите положительную площадь в кв. м',
        timelineRequired: 'Выберите сроки',
        migrashRequired: 'Укажите номер планировочного участка (migrash)',
        migrashInvalid: 'Недопустимый номер migrash',
        mapLocationRequired: 'Нажмите на участок на карте или введите корректный migrash',
        mapIdentifyFailed: 'Участок в этой точке не найден — нажмите на границу участка в слое компиляции',
        contactNameRequired: 'Укажите имя',
        contactPhoneInvalid: 'Недопустимый номер телефона',
        contactEmailInvalid: 'Недопустимый адрес эл. почты',
        consentRequired: 'Для продолжения необходимо принять заявление',
      },
      consent: {
        noticeTitle: 'Важное уведомление',
        noticeBody:
          'Информация на сайте предназначена только для предварительной оценки пригодности и не является разрешением на строительство, планировочным одобрением или обязательством властей.',
        savingHint: 'Сохраняем согласие — это может занять несколько секунд.',
        checklistTitle: 'Подтвердите все пункты, чтобы продолжить:',
        checklistItems: {
          informational:
            'Я понимаю, что информация предназначена только для предварительной оценки и не является разрешением или одобрением',
          dataProcessing:
            'Я согласен(на) на обработку контактных данных и сведений для проверки участка и открытия дела предпринимателя',
          layers:
            'Я понимаю, что планировочные данные из публичных GIS-слоёв (компиляция, XPLAN) могут быть неполными',
        },
        checkboxLabel:
          'Я понимаю, что проверка носит информационный характер и не гарантирует получение разрешения',
        checkboxAria: 'Принять заявление об ограничении ответственности',
        openFileTitle: 'Подтвердить и открыть дело предпринимателя',
        openFileConfirm:
          'Я подтверждаю, что проверил(а) информацию выше и прошу открыть дело предпринимателя в системе',
        submitConfirmRequired: 'Подтвердите запрос перед отправкой',
        submit: 'Открыть дело предпринимателя',
        submitLoading: 'Отправка дела…',
        submitSuccess: 'Дело успешно открыто',
        submitError: 'Не удалось открыть дело',
        submitProfileRequired: 'Заполните данные предпринимателя перед отправкой',
      },
    },
    langSelect: {
      languageLabel: 'Язык',
      hebrew: 'עברית',
      english: 'English',
      arabic: 'العربية',
      russian: 'Русский',
      chooseLanguageAria: 'Выбор языка',
    },
    header: {
      docs: 'Руководство пользователя',
    },
    map: {
      title: 'Выбор участка',
      subtitle:
        'Нажмите на цветную зону на карте назначения земли (компиляция) — только Восточная Галилея',
      searchLabel: 'Поиск migrash',
      hint: 'Нажмите на цветной полигон — назначение и планы появятся на следующих шагах',
      clickToSelect: 'Клик по карте',
      drawPolygon: 'Нарисовать участок',
      selectionModeGroupLabel: 'Способ выбора участка на карте',
      drawHint: 'Обведите границы участка на карте',
      clearDrawing: 'Очистить',
      drawnAreaLabel: 'Отмеченная площадь',
      layers: {
        title: 'Планировочные слои',
        migrashNote:
          'Отдельного публичного слоя migrash в XPLAN нет. Номер — из GIS-Net (если включён) или вручную.',
      },
      mapAriaLabel: 'Карта Восточной Галилеи для выбора участка',
      expandMap: 'Увеличить карту',
      collapseMap: 'Уменьшить карту',
      layersLoading: 'Загрузка слоя назначения земли…',
      confirmTitle: 'Подтвердите местоположение',
      confirmBody:
        'Место выбрано. Назначение и планы будут на быстрой оценке и странице планировочной информации.',
      confirmButton: 'Подтвердить участок',
      confirmButtonLoading: 'Сохранение участка…',
      completeTitle: 'Участок сохранён',
      completeBody: 'Выбор участка сохранён. Далее будет показана оценка пригодности (скоро).',
      errorTitle: 'Ошибка',
      fields: {
        migrash: 'Планировочный участок (migrash)',
        migrashPlaceholder: 'например: 2145 (из утверждённого плана)',
        migrashEnterHint:
          'Номер migrash: укажите номер участка комитета — не совпадает с кадастровым gush/helka',
        cadastralRef: 'Gush/helka (кадастр, справочно)',
        settlement: 'Населённый пункт',
        designation: 'Назначение',
        planPrimary: 'Основной план',
        plansAffecting: 'Планы в зоне',
        plansAtPoint: 'Планы в точке',
        area: 'Зарегистрированная площадь',
        coordinates: 'Координаты',
      },
      validation: {
        identifyFailed: 'Участок в этой точке не найден — нажмите на границу участка в слое компиляции',
        identifyTimeout: 'Определение назначения заняло слишком много времени — попробуйте снова или выберите другую точку',
        lookupFailed: 'Участок не найден — проверьте номер migrash',
        cadastralLookupFailed: 'Кадастровый участок не найден — проверьте gush/helka',
      },
      legend: {
        title: 'Легенда',
        loading: 'Загрузка легенды из XPlan…',
        loadError: 'Не удалось загрузить легенду — обновите страницу',
        summaryHint: 'Основные туристические классы — нажмите на цветную область карты',
        showFull: 'Полная легенда ({count})',
        mapFilterOpen: 'Фильтр ייעודов на карте ({count})',
        mapFilterActive: 'На карте: {shown}/{total}',
        mapFilterTitle: 'Назначения на карте — {layer}',
        mapFilterIntro: 'Отметьте, какие ייעודים показывать на слое компиляции. Изменения сразу на карте.',
        mapVisibleMeta: '{shown} из {total} ייעודов на карте',
        selectAll: 'Показать все',
        selectTourism: 'Только туризм',
        selectNone: 'Скрыть все',
        fullTitle: 'Легенда — {layer}',
        fullMeta: '{count} классов на слое компиляции XPlan',
        filteredMeta: '{shown} из {total} классов',
        filterLabel: 'Поиск в списке',
        filterPlaceholder: 'Поиск (напр. туризм, отдых, сельское…)',
        filterEmpty: 'Нет совпадений — попробуйте другой запрос',
        close: 'Закрыть',
        approvalDateHint: 'Дата утверждения плана — на странице планировочной информации (§2)',
      },
    },
    assessment: {
      title: 'Оценка пригодности участка',
      combinedTitle: 'Доступность земли и планировочная информация',
      combinedSubtitle:
        'Сначала сигнал пригодности, затем планировочный отчёт — не является разрешением',
      statusRevealLoading: 'Проверяем доступность земли…',
      statusRevealHint: 'Анализ назначения и загрузка планировочного отчёта',
      continueToQuestionnaire: 'Заполнить данные предпринимателя',
      continueToQuestionnaireHint: 'После заполнения можно открыть дело в системе',
      finishJourney: 'Завершить',
      finishJourneyHint: 'На главную — дело успешно открыто',
      ctaWaitingForReport: 'Кнопка станет активной после загрузки отчёта',
      subtitle:
        'Быстрая оценка по назначению участка на слое компиляции — не является разрешением',
      loading: 'Загрузка оценки…',
      errorTitle: 'Ошибка',
      designationTitle: 'ייעוד קרקע (компиляция):',
      detailsTitle: 'Детали оценки',
      ctaHint: 'Необязательный шаг — полный отчёт Поправки 119 (медленнее)',
      trafficLight: {
        green: 'Зелёный — туризм',
        yellow: 'Жёлтый — возможно (жилая / сельхоз / урбан)',
        red: 'Красный — заповедник, дороги',
        unknown: 'Не классифицировано на карте',
      },
      viewPlanningInfo: 'Полная планировочная информация',
      submit: 'Открыть дело предпринимателя',
      submitLoading: 'Отправка дела…',
      submitSuccess: 'Дело успешно открыто',
      submitError: 'Не удалось открыть дело',
      submitPlaceholder: 'Открыть дело предпринимателя (скоро)',
      unknownNote: 'Не удалось оценить участок — сотрудник комитета свяжется с вами после проверки.',
      status: {
        available: 'Подходит — зелёный',
        conditional: 'Условно подходит — жёлтый',
        unlikely: 'Низкая вероятность — красный',
        unknown: 'Неизвестно — требуется проверка',
      },
      rules: {
        pass: 'Пройдено',
        fail: 'Не пройдено',
        skip: 'Не применимо',
      },
    },
    planningInfo: {
      title: 'Планировочная информация — Поправка 119',
      ramzorLabel: 'Проверка пригодности',
      subtitle: 'Сводка планировочной информации по выбранному участку',
      loading: 'Загрузка планировочной информации…',
      reportLoading: 'Загрузка отчёта и извлечение прав из таканона…',
      errorTitle: 'Ошибка',
      disclaimerTitle: 'Важное уведомление',
      disclaimerBody:
        'Показанная информация — структурированная сводка для предварительной оценки пригодности. Это не планировочное одобрение, разрешение на строительство или обязательство властей. Для официального запроса используйте систему VGM.',
      lineageFooter: 'Источник данных: XPLAN (управление планирования), кадастр GovMap. Информация может изменяться.',
      reportDate: 'Дата отчёта',
      requestType: 'Тип запроса',
      section1Title: '1. Сведения об участке',
      section2Title: '2. Связанные планы',
      section3Title: '3. Права застройки и ограничения',
      section4Title: '4. Примечания',
      missingSession: 'Отсутствует идентификатор сессии',
      exportPrintFallback:
        'Экспорт PDF недоступен — открыт предпросмотр печати; выберите Печать → Сохранить как PDF.',
      openXplanLink: 'Открыть XPLAN (управление планирования)',
      xplanLineage: 'Планы и назначение из XPLAN; не отчёт местного комитета по Поправке 119.',
      xplanFallbackNote:
        'Данные XPLAN не загрузились — выберите участок на карте (нужен центроид). Можно открыть XPLAN напрямую.',
      openOfficialReport: 'Открыть XPLAN',
      vgmMatchNote: '',
      officialVgmLink: 'XPLAN',
      fetchStatus: {
        complete: '',
        partial: 'Часть данных недоступна — показана частичная сводка.',
        failed: 'Не удалось загрузить полную планировочную информацию.',
      },
      documentsTitle: 'Официальные документы (таканон)',
      documentsEmpty: 'Ссылка на таканон недоступна — попробуйте позже.',
      takanonNotFoundTitle: 'Документ таканона не найден',
      takanonNotFoundBody:
        'Не удалось найти документ таканона для плана. Показаны только данные об участке и планы из XPLAN.',
      expandTakanonRights: 'Расширить права из таканона',
      expandTakanonLoading: 'Извлечение прав из таканона…',
      extractionBannerTitle: 'Частичное извлечение таканона',
      extractionBannerBody:
        'Часть прав застройки не извлечена из таканона. Показаны §1–§2 из XPLAN и ссылка на исходный PDF.',
      extractionNotice:
        'Значения из автоматического чтения таканона — проверьте по официальному источнику.',
      extractionSectionDraftNotice:
        'Значения из автоматического чтения — не проверены по таканону.',
      extractionDraftBannerTitle: 'Таканон — не проверен',
      extractionDraftBannerBody:
        'Значения из автоматического чтения — не проверены по таканону (Sprint 7).',
      verifySource: 'Проверить по источнику',
      openPdfOnPage: 'Открыть PDF на странице',
      lowConfidence: 'низкая уверенность',
      submitTitle: 'Подтвердить и открыть дело предпринимателя',
      submitConfirm:
        'Подтверждаю, что информация выше проверена, и прошу открыть дело предпринимателя в системе',
      submitConfirmRequired: 'Подтвердите запрос перед отправкой',
      submitProfileIntro:
        'Перед открытием дела в monday заполните данные предпринимателя (даже если пропустили опросник):',
      submitProfileRequired: 'Укажите имя предпринимателя и тип проекта',
      submit: 'Открыть дело предпринимателя',
      submitLoading: 'Отправка дела…',
      submitSuccess: 'Дело успешно открыто',
      submitError: 'Не удалось открыть дело',
      exportPdf: 'Экспорт PDF',
      exportingPdf: 'Экспорт PDF…',
      exportPdfError: 'Не удалось экспортировать PDF. Попробуйте снова.',
      pdfProducedBy: 'Produced by Clicks Strategic Ecosystems',
      pdfPage: 'Страница',
      pdfProductName: 'Clicks Tourism 360',
      pdfProductTagline: 'Планировочная аналитика — Восточная Галилея',
      reportCoverSubtitle: 'Структурированный планировочный отчёт по выбранному участку',
      reportInformationalNotice:
        'Отчёт предназначен только для предварительной оценки пригодности — не является разрешением или обязательством властей.',
      reportDocumentRef: 'ID документа',
      reportSourceLabel: 'Источник данных',
      report: {
        coverBadge: 'Поправка 119',
        parcelCadastralLine: 'Блок {gush} / Участок {helka}',
        fields: {
          settlement: 'Населённый пункт',
          gush: 'Блок (גוש)',
          helka: 'Участок (חלקה)',
          areaSqm: 'Площадь (кв. м)',
          migrash: 'Планировочный участок (migrash)',
          coordinates: 'Координаты (lng, lat)',
          designationXplan: 'Назначение (XPLAN)',
        },
        blocks: {
          relatedPlans: 'Планы, связанные с участком',
          areaNotes: 'Примечания по площади',
          lotSummary: 'Сводка по участку',
          tableA: 'Таблица А — права застройки и указания',
          tableB: 'Таблица Б — парковка и линии застройки',
          editorRole: 'Роль редактора',
          editorName: 'Имя редактора',
          phone: 'Телефон',
          fax: 'Факс',
          address: 'Адрес',
          approver: 'Утверждающий',
          approverPhone: 'Телефон утверждающего',
          xplanLines: 'Утверждённые планы (синие линии / XPLAN)',
          takanonExtracted: 'Из таканона (автоматическое чтение)',
          takanonDraftNote:
            'Значения из автоматического чтения таканона — сверьте с официальным источником.',
        },
        columns: {
          parcelGush: 'Блок (גוש)',
          parcelHelkaSource: 'Исходный участок',
          parcelAreaSqm: 'Зарегистрированная площадь (кв. м)',
          planNumber: 'Номер плана',
          planName: 'Название',
          planNumberShort: '№ плана',
          lot: 'Участок',
          planType: 'Тип плана',
          planStatus: 'Статус',
          planDesignation: 'Назначение в плане',
          note: 'Примечание',
        },
        sectionTitles: {
          landDetails: 'Сведения об участке',
          relatedPlans: 'Связанные планы',
          rights: 'Права застройки и ограничения',
          notes: 'Примечания',
        },
        categories: {
          designation: 'Назначение и виды использования',
          parking: 'Парковка',
        },
        topics: {
          parkingStandard: 'Норма парковки',
        },
        sources: {
          fixture: 'Демо-данные (локальная разработка)',
          xplan: 'Управление планирования (XPLAN)',
          vgm: 'VGM / Complot (устар.)',
          gisnet: 'GIS-Net отчёт 33 (устар.)',
          gisnet_partial: 'GIS-Net (частично)',
          layers: 'Сборка слоёв GIS (резерв)',
          map_identify: 'Только слой карты',
        },
      },
    },
  },
} as const;

export type Translation = (typeof translations)[AppLanguage];
